module.exports = __webpack_public_path__ + "static/media/brain.467d92b5.png";